export const isProductionEnv = () => import.meta.env.TREAD__ENV === 'production';
